import React from 'react';
import Notes from 'Components/Notes';

export default function NotesSection ({notes, handleInputChange, disabled}) {
  return (
    <section className='scene_section'>
      <header>Component Family notes</header>
      <Notes text={notes} handleInputChange={handleInputChange('notes')} disabled={disabled} />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Edit/NotesSection.jsx